import { type FC, useCallback } from 'react';

import { TopBarNotificationType } from 'constants/notifications';
import type { IBrowserNotificationsProps } from 'interfaces/notification-bar';

import { ChangeBrowserBar } from './ChangeBrowserBar';
import { EnableNotificationsBar } from './EnableNotificationsBar';
import { UnblockNotificationsBar } from './UnblockNotififcationsBar';

interface IProps extends IBrowserNotificationsProps {
  onSkip(name: TopBarNotificationType): void;
  shouldBeVisible: boolean;
}
export const BrowserNotificationsBar: FC<IProps> = ({ type, onSkip, shouldBeVisible }) => {
  const isBarVisible = (barType: TopBarNotificationType): boolean => type === barType && shouldBeVisible;
  const handleSkipClick = useCallback((): void => {
    onSkip(TopBarNotificationType.BrowserNotifications);
  }, [onSkip]);

  return (
    <>
      <ChangeBrowserBar isVisible={isBarVisible(TopBarNotificationType.ChangeBrowser)} onSkip={handleSkipClick} />
      <EnableNotificationsBar
        isVisible={isBarVisible(TopBarNotificationType.EnableNotifications)}
        onSkip={handleSkipClick}
      />
      <UnblockNotificationsBar
        isVisible={isBarVisible(TopBarNotificationType.UnblockNotifications)}
        onSkip={handleSkipClick}
      />
    </>
  );
};
